import { useQuery } from "@apollo/client";

import { ProjectReviewVisitV2WeatherReportsRoute_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2WeatherReportsRoute_GetData(visitId: string) {
    const { data, loading, error, previousData } = useQuery(ProjectReviewVisitV2WeatherReportsRoute_GetDataDocument, {
        variables: { visitId },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    const result = loading ? previousData : data;
    const visit = result?.plannerV2VisitGetById;

    const isOverridden =
        visit?.weatherProtocolAutoValidationOverriddenAt != null &&
        visit?.weatherProtocolAutoValidationOverriddenReason != null;

    return {
        visit,
        weatherReport: result?.plannerVisitWeatherReportGetByVisitId,
        hasAllWeatherConditionsValid: result?.plannerVisitHasAllWeatherConditionsValid,
        isOverridden,
        loading,
        error,
    };
}
